<div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-5">
    <div
        class="tw-grid tw-grid-cols-1 tw-col-span-1 tw-border-0 tw-content-center tw-justify-items-start md:tw-content-start md:tw-justify-items-center tw-pb-0 md:tw-pb-4 tw-px-0 tw-mb-6"
    >
        <span
            class="tw-mb-5 md:tw-mb-6 tw-px-[4px] tw-py-[5px] tw-text-[12px] tw-font-semibold tw-uppercase"
            >{{ "FOOTER.POWERED_BY" | translate }}</span
        >
        <a
            target="_blank"
            href="https://cgcdigital.com.my/ "
            class="tw-inline-block tw-hover:opacity-80 tw-transition-opacity"
        >
            <img
                [attr.ga-event-id]="gtmTags.CGC_DIGI_ICON?.event"
                [attr.ga-event-category]="gtmTags.CGC_DIGI_ICON?.event_category"
                [attr.ga-event-label]="gtmTags.CGC_DIGI_ICON?.event_label"
                ga-track="track"
                src="/assets/images/logo/FOOTER_CGC_DIG.svg"
                class="tw-h-[39px] tw-w-[59px] md:tw-h-[50px] md:tw-w-[74px] xl:tw-w-[104px] xl:tw-h-[69px]"
                alt="CGC Digital Logo"
            />
        </a>
    </div>

    <div
        class="tw-grid tw-grid-cols-1 tw-col-span-3 md:tw-border-x-[0.5px] md:tw-border-[#4B6EEC] tw-content-center tw-justify-items-start md:tw-content-start md:tw-justify-items-center tw-px-0 tw-pb-0 md:tw-pb-4 md:tw-px-[5px] tw-mb-4 md:tw-mb-6"
    >
        <span
            class="tw-mb-5 md:tw-mb-6 tw-px-[4px] tw-py-[5px] tw-text-[12px] tw-font-semibold tw-uppercase"
            >{{ "FOOTER.SUPPORTED_BY" | translate }}</span
        >

        <div
            class="tw-grid tw-grid-cols-3 tw-w-full tw-items-start tw-justify-items-start md:tw-justify-items-center tw-gap-[30px] md:tw-gap-[20px]"
        >
            <a
                target="_blank"
                [href]="
                    selectedLanguage === 'en'
                        ? 'https://www.cgc.com.my/en-us/'
                        : 'https://www.cgc.com.my/ms-my/'
                "
                class="tw-inline-block tw-hover:opacity-80 tw-transition-opacity"
            >
                <img
                    [attr.ga-event-id]="gtmTags.CGC_ICON?.event"
                    [attr.ga-event-category]="gtmTags.CGC_ICON?.event_category"
                    [attr.ga-event-label]="gtmTags.CGC_ICON?.event_label"
                    ga-track="track"
                    src="/assets/images/logo/FOOTER_CGC.svg"
                    class="tw-h-[30px] tw-w-[64px] md:tw-w-[77px] md:tw-h-[36px] xl:tw-w-[106px] xl:tw-h-[49px]"
                    alt="CGC Corporate Logo"
                />
            </a>
            <a
                target="_blank"
                href="https://www.bnm.gov.my/"
                class="tw-inline-block tw-hover:opacity-80 tw-transition-opacity"
            >
                <img
                    [attr.ga-event-id]="gtmTags.Bank_Negara?.event"
                    [attr.ga-event-category]="
                        gtmTags.Bank_Negara?.event_category
                    "
                    [attr.ga-event-label]="gtmTags.Bank_Negara?.event_label"
                    ga-track="track"
                    src="/assets/images/logo/FOOTER_BNM.svg"
                    class="tw-h-[52px] tw-w-[116px] md:tw-w-[159px] md:tw-h-[71px] xl:tw-h-[96px] xl:tw-w-[214px]"
                    alt="Bank Negara Malaysia Logo"
                />
            </a>
            <a
                target="_blank"
                href="https://www.sc.com.my/"
                class="tw-inline-block tw-hover:opacity-80 tw-transition-opacity"
            >
                <img
                    [attr.ga-event-id]="gtmTags.SCSC?.event"
                    [attr.ga-event-category]="gtmTags.SCSC?.event_category"
                    [attr.ga-event-label]="gtmTags.SCSC?.event_label"
                    ga-track="track"
                    src="/assets/images/logo/SC_Malaysia_1.png"
                    class="tw-h-[51px] tw-w-[70px] tw-rounded md:tw-w-[96px] md:tw-h-[71px] xl:tw-w-[138px] xl:tw-h-[102px]"
                    alt="MNB Logo"
                />
            </a>
        </div>
    </div>

    <div
        class="tw-grid tw-grid-cols-1 tw-col-span-1 tw-border-0 tw-content-center tw-justify-items-start md:tw-content-start md:tw-justify-items-center tw-pb-0 md:tw-pb-4 tw-px-0 tw-mb-7 md:tw-mb-6"
    >
        <span
            class="tw-mb-5 md:tw-mb-6 tw-px-[4px] tw-py-[5px] tw-text-[12px] tw-font-semibold tw-uppercase"
            >{{ "FOOTER.ESG_PARTNER" | translate }}</span
        >
        <a
            [routerLink]="['/jc3-esg-jumpstart-for-smes']"
            class="tw-inline-block tw-hover:opacity-80 tw-transition-opacity"
        >
            <img
                [attr.ga-event-id]="gtmTags.JC3?.event"
                [attr.ga-event-category]="gtmTags.JC3?.event_category"
                [attr.ga-event-label]="gtmTags.JC3?.event_label"
                ga-track="track"
                src="/assets/images/logo/FOOTER_JC3.svg"
                class="tw-h-[33px] tw-w-[125px] tw-rounded md:tw-w-[129px] md:tw-h-[30px] xl:tw-w-[206px] xl:tw-h-[54px]"
                alt="JC3 Logo"
            />
        </a>
    </div>
</div>

<div
    class="tw-flex tw-flex-col md:tw-flex-row tw-justify-between tw-items-start md:tw-items-center tw-gap-6"
>
    <!-- Mobile: Social Media Section First -->
    <div class="tw-block md:tw-hidden tw-w-full tw-h-[20.79px]">
        <span
            class="tw-text-white tw-text-[12px] tw-font-semibold tw-uppercase tw-tracking-wider !tw-text-left tw-mb-6"
        >
            {{ "FOOTER.FOLLOW_US" | translate }}
        </span>
        <div
            class="tw-flex tw-flex-row tw-items-center tw-gap-7 !tw-justify-start tw-mb-8 tw-mt-3"
        >
            <!-- Facebook -->
            <a
                [attr.ga-event-id]="gtmTags.Network_Facebook.event"
                [attr.ga-event-category]="
                    gtmTags.Network_Facebook.event_category
                "
                [attr.ga-event-label]="gtmTags.Network_Facebook.event_label"
                ga-track="track"
                target="_blank"
                href="https://www.facebook.com/profile.php?id=61552185373254"
                class="tw-text-[#828f9c] tw-hover:text-gray-900 tw-dark:hover:text-white"
            >
                <img
                    src="/assets/images/social/FB.svg"
                    class="tw-h-[21.5px] tw-w-[20.7px]"
                />
            </a>

            <!-- Instagram -->
            <a
                target="_blank"
                [attr.ga-event-id]="gtmTags.Network_Instagram.event"
                [attr.ga-event-category]="
                    gtmTags.Network_Instagram.event_category
                "
                [attr.ga-event-label]="gtmTags.Network_Instagram.event_label"
                ga-track="track"
                href="http://www.instagram.com/cgcdigital.my"
                class="tw-text-[#828f9c] tw-hover:text-gray-900 tw-dark:hover:text-white"
            >
                <img
                    src="/assets/images/social/Vector_2.svg"
                    class="tw-h-[21.5px] tw-w-[20.7px]"
                />
            </a>
            <a
                target="_blank"
                [attr.ga-event-id]="gtmTags.Network_Youtube.event"
                [attr.ga-event-category]="
                    gtmTags.Network_Youtube.event_category
                "
                [attr.ga-event-label]="gtmTags.Network_Youtube.event_label"
                ga-track="track"
                href="https://www.youtube.com/@CGCDigitalMY"
                class="tw-text-[#828f9c] tw-hover:text-gray-900 tw-dark:hover:text-white"
            >
                <img
                    src="/assets/images/social/instagram.svg"
                    class="tw-h-[21.5px] tw-w-[20.7px]"
                />
            </a>
            <a
                target="_blank"
                [attr.ga-event-id]="gtmTags.Network_Linkedin.event"
                [attr.ga-event-category]="
                    gtmTags.Network_Linkedin.event_category
                "
                [attr.ga-event-label]="gtmTags.Network_Linkedin.event_label"
                ga-track="track"
                href="https://www.linkedin.com/company/cgc-digital"
                class="tw-text-[#828f9c] tw-hover:text-gray-900 tw-dark:hover:text-white"
            >
                <img
                    src="/assets/images/social/Youtube.svg"
                    class="tw-h-[21.5px] tw-w-[20.7px]"
                />
            </a>
            <a
                target="_blank"
                [attr.ga-event-id]="gtmTags.Network_X.event"
                [attr.ga-event-category]="gtmTags.Network_X.event_category"
                [attr.ga-event-label]="gtmTags.Network_X.event_label"
                ga-track="track"
                href="https://twitter.com/cgcdigitalmy"
                class="tw-text-[#828f9c] tw-hover:text-gray-900 tw-dark:hover:text-white"
            >
                <img
                    src="/assets/images/social/Vector.svg"
                    class="tw-h-[21.5px] tw-w-[20.7px]"
                />
            </a>
        </div>

        <!-- Mobile: Links Section Below Social Media -->
        <div class="tw-flex tw-flex-wrap tw-gap-6 !tw-justify-start">
            <!-- Terms of Use -->
            <a
                href="/assets/documents/Terms of Use (EN).pdf"
                *ngIf="selectedLanguage == 'en'"
                target="_blank"
                class="tw-text-white tw-text-[12px] tw-font-semibold tw-hover:underline tw-hover:opacity-100 tw-transition-all tw-uppercase tw-tracking-wider"
            >
                {{ "FOOTER.TERMS_OF_USE" | translate }}
            </a>
            <a
                href="/assets/documents/Terma Penggunaan(BM).pdf"
                *ngIf="selectedLanguage == 'bm'"
                target="_blank"
                class="tw-text-white tw-text-[12px] tw-font-semibold tw-hover:underline tw-hover:opacity-100 tw-transition-all tw-uppercase tw-tracking-wider"
            >
                {{ "FOOTER.TERMS_OF_USE" | translate }}
            </a>

            <!-- Privacy Policy -->
            <a
                href="/assets/documents/Privacy & Security Policies.pdf"
                *ngIf="selectedLanguage == 'en'"
                target="_blank"
                class="tw-text-white tw-text-[12px] tw-font-semibold tw-hover:underline tw-hover:opacity-100 tw-transition-all tw-uppercase tw-tracking-wider"
            >
                {{ "FOOTER.PRIVACY_POLICY" | translate }}
            </a>
            <a
                href="/assets/documents/Polisi Privasi(BM).pdf"
                *ngIf="selectedLanguage == 'bm'"
                target="_blank"
                class="tw-text-white tw-text-[12px] tw-font-semibold tw-hover:underline tw-hover:opacity-100 tw-transition-all tw-uppercase tw-tracking-wider"
            >
                {{ "FOOTER.PRIVACY_POLICY" | translate }}
            </a>

            <!-- FAQ -->
            <a
                [routerLink]="['/faq']"
                class="tw-text-white tw-text-[12px] tw-font-semibold tw-hover:underline tw-hover:opacity-100 tw-transition-all tw-uppercase tw-tracking-wider"
            >
                {{ "COMMON.FAQ" | translate }}
            </a>
        </div>
    </div>

    <!-- Desktop Layout: Links Left, Social Right -->
    <div
        class="tw-hidden md:tw-flex md:tw-flex-row md:tw-justify-between md:tw-items-center md:tw-w-full"
    >
        <!-- Links Section - Left on Desktop -->
        <div class="tw-flex tw-flex-wrap tw-gap-8">
            <!-- Terms of Use -->
            <a
                href="/assets/documents/Terms of Use (EN).pdf"
                *ngIf="selectedLanguage == 'en'"
                target="_blank"
                class="tw-text-white tw-text-[12px] tw-font-semibold tw-hover:underline tw-hover:opacity-100 tw-transition-all tw-uppercase tw-tracking-wider"
            >
                {{ "FOOTER.TERMS_OF_USE" | translate }}
            </a>
            <a
                href="/assets/documents/Terma Penggunaan(BM).pdf"
                *ngIf="selectedLanguage == 'bm'"
                target="_blank"
                class="tw-text-white tw-text-[12px] tw-font-semibold tw-hover:underline tw-hover:opacity-100 tw-transition-all tw-uppercase tw-tracking-wider"
            >
                {{ "FOOTER.TERMS_OF_USE" | translate }}
            </a>

            <!-- Privacy Policy -->
            <a
                href="/assets/documents/Privacy & Security Policies.pdf"
                *ngIf="selectedLanguage == 'en'"
                target="_blank"
                class="tw-text-white tw-text-[12px] tw-font-semibold tw-hover:underline tw-hover:opacity-100 tw-transition-all tw-uppercase tw-tracking-wider"
            >
                {{ "FOOTER.PRIVACY_POLICY" | translate }}
            </a>
            <a
                href="/assets/documents/Polisi Privasi(BM).pdf"
                *ngIf="selectedLanguage == 'bm'"
                target="_blank"
                class="tw-text-white tw-text-[12px] tw-font-semibold tw-hover:underline tw-hover:opacity-100 tw-transition-all tw-uppercase tw-tracking-wider"
            >
                {{ "FOOTER.PRIVACY_POLICY" | translate }}
            </a>

            <!-- FAQ -->
            <a
                [routerLink]="['/faq']"
                class="tw-text-white tw-text-[12px] tw-font-semibold tw-hover:underline tw-hover:opacity-100 tw-transition-all tw-uppercase tw-tracking-wider"
            >
                {{ "COMMON.FAQ" | translate }}
            </a>
        </div>

        <!-- Social Media Section - Right on Desktop -->
        <div class="tw-flex tw-flex-row tw-items-center tw-gap-4">
            <span
                class="tw-text-white tw-text-[12px] tw-font-semibold tw-uppercase tw-tracking-wider"
            >
                {{ "FOOTER.FOLLOW_US" | translate }}
            </span>
            <div class="tw-flex tw-flex-row tw-items-center tw-gap-7">
                <!-- All social media icons here - same as mobile but without the mobile-specific classes -->
                <!-- Facebook -->
                <a
                    [attr.ga-event-id]="gtmTags.Network_Facebook.event"
                    [attr.ga-event-category]="
                        gtmTags.Network_Facebook.event_category
                    "
                    [attr.ga-event-label]="gtmTags.Network_Facebook.event_label"
                    ga-track="track"
                    target="_blank"
                    href="https://www.facebook.com/profile.php?id=61552185373254"
                    class="tw-text-[#828f9c] tw-hover:text-gray-900 tw-dark:hover:text-white"
                >
                    <img
                        src="/assets/images/social/FB.svg"
                        class="tw-h-[21.5px] tw-w-[20.7px]"
                    />
                </a>

                <!-- Instagram -->
                <a
                    target="_blank"
                    [attr.ga-event-id]="gtmTags.Network_Instagram.event"
                    [attr.ga-event-category]="
                        gtmTags.Network_Instagram.event_category
                    "
                    [attr.ga-event-label]="
                        gtmTags.Network_Instagram.event_label
                    "
                    ga-track="track"
                    href="http://www.instagram.com/cgcdigital.my"
                    class="tw-text-[#828f9c] tw-hover:text-gray-900 tw-dark:hover:text-white"
                >
                    <img
                        src="/assets/images/social/instagram.svg"
                        class="tw-h-[21.5px] tw-w-[20.7px]"
                    />
                </a>

                <!-- YouTube -->
                <a
                    target="_blank"
                    [attr.ga-event-id]="gtmTags.Network_Youtube.event"
                    [attr.ga-event-category]="
                        gtmTags.Network_Youtube.event_category
                    "
                    [attr.ga-event-label]="gtmTags.Network_Youtube.event_label"
                    ga-track="track"
                    href="https://www.youtube.com/@CGCDigitalMY"
                    class="tw-text-[#828f9c] tw-hover:text-gray-900 tw-dark:hover:text-white"
                >
                    <img
                        src="/assets/images/social/Youtube.svg"
                        class="tw-h-[21.5px] tw-w-[20.7px]"
                    />
                </a>

                <!-- LinkedIn -->
                <a
                    target="_blank"
                    [attr.ga-event-id]="gtmTags.Network_Linkedin.event"
                    [attr.ga-event-category]="
                        gtmTags.Network_Linkedin.event_category
                    "
                    [attr.ga-event-label]="gtmTags.Network_Linkedin.event_label"
                    ga-track="track"
                    href="https://www.linkedin.com/company/cgc-digital"
                    class="tw-text-[#828f9c] tw-hover:text-gray-900 tw-dark:hover:text-white"
                >
                    <img
                        src="/assets/images/social/Vector_2.svg"
                        class="tw-h-[21.5px] tw-w-[20.7px]"
                    />
                </a>

                <!-- X (Twitter) -->
                <a
                    target="_blank"
                    [attr.ga-event-id]="gtmTags.Network_X.event"
                    [attr.ga-event-category]="gtmTags.Network_X.event_category"
                    [attr.ga-event-label]="gtmTags.Network_X.event_label"
                    ga-track="track"
                    href="https://twitter.com/cgcdigitalmy"
                    class="tw-text-[#828f9c] tw-hover:text-gray-900 tw-dark:hover:text-white"
                >
                    <img
                        src="/assets/images/social/Vector.svg"
                        class="tw-h-[21.5px] tw-w-[20.7px]"
                    />
                </a>
            </div>
        </div>
    </div>
</div>
